import classNames from 'classnames';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Information({
  className = '',
  name = '',
  cognitoAppClientId = '',
  cognitoProviderName = '',
  disableInput = false,
  onUpdate = () => {},
}) {
  /**
   * When a text field is changed
   */
  const onChange = (e) => {
    const {
      target: {
        name: fieldName,
        value,
      },
    } = e;

    onUpdate({
      [fieldName]: value,
    });
  };

  return (
    <Grid className={classNames('Information', 'identity-provider', className)} spacing={2} container>
      <Grid size={12}>
        <Field
          type="text"
          label="Name"
          name="name"
          placeholder="Name"
          value={name}
          disabled={disableInput}
          tabIndex={1}
          testId="identity-provider-name-input"
          onChange={onChange}
          autoFocus
          required
        />
      </Grid>

      <Grid size={12}>
        <Field
          type="text"
          label="App Client ID"
          name="cognitoAppClientId"
          placeholder="Cognito app client ID"
          value={cognitoAppClientId}
          disabled={disableInput}
          tabIndex={2}
          testId="identity-provider-cognito-app-client-id-input"
          onChange={onChange}
          required
        />
      </Grid>

      <Grid size={12}>
        <Field
          type="text"
          label="App Provider Name"
          name="cognitoProviderName"
          placeholder="Cognito identity provider name (e.g. MyTenantSAML)"
          value={cognitoProviderName}
          disabled={disableInput}
          tabIndex={3}
          testId="identity-provider-cognito-provider-name-input"
          onChange={onChange}
          required
        />
      </Grid>
    </Grid>
  );
}

export default Information;
